import { render, staticRenderFns } from "./BirthDateInput.vue?vue&type=template&id=471a75c8&"
import script from "./BirthDateInput.vue?vue&type=script&lang=ts&"
export * from "./BirthDateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports